import { render } from "./PokemonDetail.vue?vue&type=template&id=1957b671&scoped=true"
import script from "./PokemonDetail.vue?vue&type=script&lang=js"
export * from "./PokemonDetail.vue?vue&type=script&lang=js"

import "./PokemonDetail.vue?vue&type=style&index=0&id=1957b671&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1957b671"]])

export default __exports__